import React from 'react'
import { Box, Heading, Link, Text, VStack, ListItem, UnorderedList, Button } from '@chakra-ui/react'
import Layout from '../components/Layout'
import ScholarshipApplicationEmbed from '../components/ScholarshipApplicationEmbed'
import { ExternalLinkIcon } from '@chakra-ui/icons'

const ScholarshipApplication: React.FC = () => {
  // Toggle this to control whether the application CTA is active.
  const applicationIsOpen = false
  const applicationUrl =
    'https://docs.google.com/forms/d/e/1FAIpQLSdCGt7URZL33s4UP_kx4ytECiyeQA1KHlMIYxM1fBpi1QNvrA/viewform'

  return (
    <Layout page_title=''>
      {!applicationIsOpen && (
        <Box
          mb={6}
          p={4}
          bg='red.50'
          borderRadius='lg'
          border='2px solid'
          borderColor='red.200'
          textAlign='center'>
          <Text fontWeight='bold' color='red.500' fontSize='lg'>
            The application is currently closed.
          </Text>
          <Text mt={2}>
            Please check back for the next scholarship application cycle.
          </Text>
        </Box>
      )}
      <Box mt={8} mb={8}>
        <Heading
          as='h2'
          marginLeft='-15px'
          size='lg'
          mb={4}
          fontFamily='Cherry Swash'
          color='blue.500'>
          Scholarship Application
        </Heading>
        <VStack spacing={6} align='stretch'>
          <Box>
            <Text fontWeight='bold' mb={2}>
              Important Note:
            </Text>
            <Text>
              This application can be saved and edited at any time prior to March 15th.
            </Text>
          </Box>

          <Box>
            <Heading
              as='h3'
              size='md'
              mb={4}
              fontFamily='Cherry Swash'
              color='blue.500'>
              Application must include:
            </Heading>
            <UnorderedList spacing={2}>
              <ListItem>Graduating year transcript</ListItem>
              <ListItem>Letter of recommendation</ListItem>
              <ListItem>
                Video submission - This must be a 3-to-5-minute video
              </ListItem>
            </UnorderedList>
          </Box>

          <Box>
            <Heading
              as='h3'
              size='md'
              mb={4}
              fontFamily='Cherry Swash'
              color='blue.500'>
              Details of video submission:
            </Heading>
            <VStack spacing={3} align='stretch'>
              <Text>
                Create a 3-5-minute video expressing your personality while answering each of the 3 prompts below:
              </Text>
              <Text fontWeight='bold'>
                NOTE: Applicant must be featured and visible in the video
              </Text>
            </VStack>
          </Box>

          <Box>
            <Heading
              as='h3'
              size='md'
              mb={4}
              fontFamily='Cherry Swash'
              color='blue.500'>
              The 3 prompts are:
            </Heading>

            <VStack spacing={6} align='stretch'>
              <Box>
                <Heading
                  as='h4'
                  size='sm'
                  mb={2}
                  fontFamily='Cherry Swash'
                  color='blue.500'>
                  1. "Show Us Your SHINE!"
                </Heading>
                <Text mb={2}>
                  <Text as='span' fontWeight='bold'>Prompt:</Text> What are you most passionate about and what brings out your SHINE? This can be a hobby, project, or experience that brings you joy. Tell us what it is, why it matters to you, and how it reflects the spirit of creativity and enthusiasm. SHOW US YOUR SHINE.
                </Text>
                <Text>
                  <Text as='span' fontWeight='bold'>Tips:</Text> Use visuals (like clips of you participating in your passion) and explain how this passion influences your life and aspirations.
                </Text>
              </Box>

              <Box>
                <Heading
                  as='h4'
                  size='sm'
                  mb={2}
                  fontFamily='Cherry Swash'
                  color='blue.500'>
                  2. "Inspiring Others"
                </Heading>
                <Text mb={2}>
                  <Text as='span' fontWeight='bold'>Prompt:</Text> Describe a time when you inspired someone else or made a positive impact in your community. What did you do, and how did it make you feel? How do you plan to continue spreading positivity and creativity in the future?
                </Text>
                <Text>
                  <Text as='span' fontWeight='bold'>Tips:</Text> Share personal anecdotes and highlight specific actions you took.
                </Text>
              </Box>

              <Box>
                <Heading
                  as='h4'
                  size='sm'
                  mb={2}
                  fontFamily='Cherry Swash'
                  color='blue.500'>
                  3. "Make the World Brighter"
                </Heading>
                <Text mb={2}>
                  <Text as='span' fontWeight='bold'>Prompt:</Text> How do you plan to continue to shine and brighten the world around you? In your video, share how you plan to embrace this spirit in your daily life and future endeavors. What steps will you take to embody creativity, enthusiasm, and joy in everything you do?
                </Text>
                <Text>
                  <Text as='span' fontWeight='bold'>Tips:</Text> Be authentic and relatable.
                </Text>
              </Box>
            </VStack>
          </Box>

          <Box>
            <Heading
              as='h3'
              size='md'
              mb={4}
              fontFamily='Cherry Swash'
              color='blue.500'>
              ***Additional Tips for Applicants***
            </Heading>
            <VStack spacing={2} align='stretch'>
              <Text>
                <Text as='span' fontWeight='bold'>Be Creative:</Text> Use music, visuals, or props to enhance your presentation and make it engaging.
              </Text>
              <Text>
                <Text as='span' fontWeight='bold'>Stay Authentic:</Text> Speak from the heart and let your personality shine through.
              </Text>
              <Text>
                <Text as='span' fontWeight='bold'>Practice:</Text> Rehearse your responses to ensure you stay within the time limit and communicate your thoughts clearly.
              </Text>
            </VStack>
          </Box>

          <Box>
            <Text fontWeight='bold' color='red.500'>
              Incomplete applications will not be considered.
            </Text>
          </Box>

          <Box mt={8} p={6} bg='blue.50' borderRadius='lg' border='2px solid' borderColor='blue.200' textAlign='center'>
            <Heading
              as='h3'
              size='md'
              mb={4}
              fontFamily='Cherry Swash'
              color='blue.500'>
              Ready to Apply?
            </Heading>
            {!applicationIsOpen && (
              <Box
                mb={4}
                p={4}
                bg='red.50'
                borderRadius='md'
                border='2px solid'
                borderColor='red.200'>
                <Text fontWeight='bold' color='red.500'>
                  Application closed
                </Text>
                <Text mt={1}>
                  The submission window is not currently open.
                </Text>
              </Box>
            )}
            <Text mb={4} fontSize='lg' fontWeight='medium'>
              Click the button below to start your application:
            </Text>
            {applicationIsOpen ? (
              <Button
                as={Link}
                isExternal
                href={applicationUrl}
                colorScheme='blue'
                size='lg'
                fontSize='xl'
                fontWeight='bold'
                px={8}
                py={6}
                _hover={{
                  transform: 'scale(1.05)',
                  boxShadow: 'lg',
                }}
                transition='all 0.2s'>
                Start Your Application
                <ExternalLinkIcon ml={2} />
              </Button>
            ) : (
              <Button
                isDisabled
                colorScheme='blue'
                size='lg'
                fontSize='xl'
                fontWeight='bold'
                px={8}
                py={6}
                cursor='not-allowed'
                _hover={{
                  transform: 'none',
                  boxShadow: 'none',
                }}
                transition='all 0.2s'>
                Start Your Application
              </Button>
            )}
          </Box>
        </VStack>
      </Box>
    </Layout>
  )
}

export default ScholarshipApplication
